import { Country } from '.';

export const flags: {
  [country in Country]: string;
} = {
  /* Afghanistan */ AF: '🇦🇫',
  /* Albania */ AL: '🇦🇱',
  /* Algeria */ DZ: '🇩🇿',
  /* Andorra */ AD: '🇦🇩',
  /* Angola */ AO: '🇦🇴',
  /* Antarctica */ AQ: '🇦🇶',
  /* Antigua & Barbuda */ AG: '🇦🇬',
  /* Argentina */ AR: '🇦🇷',
  /* Armenia */ AM: '🇦🇲',
  /* Aruba */ AW: '🇦🇼',
  /* Australia */ AU: '🇦🇺',
  /* Austria */ AT: '🇦🇹',
  /* Azerbaijan */ AZ: '🇦🇿',
  /* Bahamas */ BS: '🇧🇸',
  /* Bahrain */ BH: '🇧🇭',
  /* Bangladesh */ BD: '🇧🇩',
  /* Barbados */ BB: '🇧🇧',
  /* Belarus */ BY: '🇧🇾',
  /* Belgium */ BE: '🇧🇪',
  /* Belize */ BZ: '🇧🇿',
  /* Benin */ BJ: '🇧🇯',
  /* Bermuda */ BM: '🇧🇲',
  /* Bhutan */ BT: '🇧🇹',
  /* Bolivia */ BO: '🇧🇴',
  /* Bosnia & Herzegovina */ BA: '🇧🇦',
  /* Botswana */ BW: '🇧🇼',
  /* Brazil */ BR: '🇧🇷',
  /* British Virgin Islands */ VG: '🇻🇬',
  /* Brunei */ BN: '🇧🇳',
  /* Bulgaria */ BG: '🇧🇬',
  /* Burkina Faso */ BF: '🇧🇫',
  /* Burundi */ BI: '🇧🇮',
  /* Cambodia */ KH: '🇰🇭',
  /* Cameroon */ CM: '🇨🇲',
  /* Canada */ CA: '🇨🇦',
  /* Cape Verde */ CV: '🇨🇻',
  /* Caribbean Netherlands */ BQ: '🇧🇶',
  /* Cayman Islands */ KY: '🇰🇾',
  /* Chad */ TD: '🇹🇩',
  /* Chile */ CL: '🇨🇱',
  /* China */ CN: '🇨🇳',
  /* Colombia */ CO: '🇨🇴',
  /* Congo - Kinshasa */ CD: '🇨🇩',
  /* Costa Rica */ CR: '🇨🇷',
  /* Croatia */ HR: '🇭🇷',
  /* Cuba */ CU: '🇨🇺',
  /* Curaçao */ CW: '🇨🇼',
  /* Cyprus */ CY: '🇨🇾',
  /* Czech Republic */ CZ: '🇨🇿',
  /* Côte d’Ivoire */ CI: '🇨🇮',
  /* Denmark*/ DK: '🇩🇰',
  /* Dominican Republic */ DO: '🇩🇴',
  /* Ecuador */ EC: '🇪🇨',
  /* Egypt */ EG: '🇪🇬',
  /* El Salvador */ SV: '🇸🇻',
  /* Equatorial Guinea */ GQ: '🇬🇶',
  /* Estonia */ EE: '🇪🇪',
  /* Eswatini */ SZ: '🇸🇿',
  /* Ethiopia */ ET: '🇪🇹',
  /* Europe */ EU: '🇪🇺',
  /* Falkland Islands (Islas Malvinas) */ FK: '🇫🇰',
  /* Faroe Islands */ FO: '🇫🇴',
  /* Fiji */ FJ: '🇫🇯',
  /* Finland */ FI: '🇫🇮',
  /* France */ FR: '🇫🇷',
  /* French Polynesia */ PF: '🇵🇫',
  /* Gabon */ GA: '🇬🇦',
  /* Gambia */ GM: '🇬🇲',
  /* Georgia */ GE: '🇬🇪',
  /* Germany */ DE: '🇩🇪',
  /* Ghana */ GH: '🇬🇭',
  /* Gibraltar */ GI: '🇬🇮',
  /* Greece */ GR: '🇬🇷',
  /* Grenada */ GD: '🇬🇩',
  /* Guadeloupe */ GP: '🇬🇵',
  /* Guam */ GU: '🇬🇺',
  /* Guatemala */ GT: '🇬🇹',
  /* Guernsey */ GG: '🇬🇬',
  /* Guyana */ GY: '🇬🇾',
  /* Haiti */ HT: '🇭🇹',
  /* Honduras */ HN: '🇭🇳',
  /* Hong Kong */ HK: '🇭🇰',
  /* Hungary */ HU: '🇭🇺',
  /* Iceland */ IS: '🇮🇸',
  /* India */ IN: '🇮🇳',
  /* Indonesia */ ID: '🇮🇩',
  /* Iran */ IR: '🇮🇷',
  /* Iraq */ IQ: '🇮🇶',
  /* Ireland */ IE: '🇮🇪',
  /* Israel */ IL: '🇮🇱',
  /* Italy */ IT: '🇮🇹',
  /* Jamaica */ JM: '🇯🇲',
  /* Japan */ JP: '🇯🇵',
  /* Jersey */ JE: '🇯🇪',
  /* Jordan */ JO: '🇯🇴',
  /* Kazakhstan */ KZ: '🇰🇿',
  /* Kenya */ KE: '🇰🇪',
  /* Kosovo */ XK: '🇽🇰',
  /* Kuwait */ KW: '🇰🇼',
  /* Kyrgyzstan */ KG: '🇰🇬',
  /* Laos */ LA: '🇱🇦',
  /* Latvia */ LV: '🇱🇻',
  /* Lebanon */ LB: '🇱🇧',
  /* Lesotho */ LS: '🇱🇸',
  /* Libya */ LY: '🇱🇾',
  /* Liechtenstein */ LI: '🇱🇮',
  /* Lithuania */ LT: '🇱🇹',
  /* Luxembourg */ LU: '🇱🇺',
  /* Macao */ MO: '🇲🇴',
  /* Madagascar */ MG: '🇲🇬',
  /* Malawi */ MW: '🇲🇼',
  /* Malaysia */ MY: '🇲🇾',
  /* Maldives */ MV: '🇲🇻',
  /* Mali */ ML: '🇲🇱',
  /* Malta */ MT: '🇲🇹',
  /* Martinique */ MQ: '🇲🇶',
  /* Mauritania */ MR: '🇲🇷',
  /* Mauritius */ MU: '🇲🇺',
  /* Mayotte */ YT: '🇾🇹',
  /* Mexico */ MX: '🇲🇽',
  /* Micronesia */ FM: '🇫🇲',
  /* Moldova */ MD: '🇲🇩',
  /* Monaco */ MC: '🇲🇨',
  /* Mongolia */ MN: '🇲🇳',
  /* Montenegro */ ME: '🇲🇪',
  /* Morocco */ MA: '🇲🇦',
  /* Mozambique */ MZ: '🇲🇿',
  /* Myanmar (Burma) */ MM: '🇲🇲',
  /* Namibia */ NA: '🇳🇦',
  /* Nepal */ NP: '🇳🇵',
  /* Netherlands */ NL: '🇳🇱',
  /* New Caledonia */ NC: '🇳🇨',
  /* New Zealand */ NZ: '🇳🇿',
  /* Nicaragua */ NI: '🇳🇮',
  /* Niger */ NE: '🇳🇪',
  /* Nigeria */ NG: '🇳🇬',
  /* Norfolk Island */ NF: '🇳🇫',
  /* North Macedonia */ MK: '🇲🇰',
  /* Norway */ NO: '🇳🇴',
  /* Oman */ OM: '🇴🇲',
  /* Pakistan */ PK: '🇵🇰',
  /* Palestine */ PS: '🇵🇸',
  /* Panama */ PA: '🇵🇦',
  /* Papua New Guinea */ PG: '🇵🇬',
  /* Paraguay */ PY: '🇵🇾',
  /* Peru */ PE: '🇵🇪',
  /* Philippines */ PH: '🇵🇭',
  /* Poland */ PL: '🇵🇱',
  /* Portugal */ PT: '🇵🇹',
  /* Puerto Rico */ PR: '🇵🇷',
  /* Qatar */ QA: '🇶🇦',
  /* Romania */ RO: '🇷🇴',
  /* Russia */ RU: '🇷🇺',
  /* Rwanda */ RW: '🇷🇼',
  /* Réunion */ RE: '🇷🇪',
  /* San Marino */ SM: '🇸🇲',
  /* Saudi Arabia */ SA: '🇸🇦',
  /* Senegal */ SN: '🇸🇳',
  /* Serbia */ RS: '🇷🇸',
  /* Seychelles */ SC: '🇸🇨',
  /* Sierra Leone */ SL: '🇸🇱',
  /* Singapore */ SG: '🇸🇬',
  /* Slovakia */ SK: '🇸🇰',
  /* Slovenia */ SI: '🇸🇮',
  /* Somalia */ SO: '🇸🇴',
  /* South Africa */ ZA: '🇿🇦',
  /* South Korea */ KR: '🇰🇷',
  /* South Sudan */ SS: '🇸🇸',
  /* Spain */ ES: '🇪🇸',
  /* Sri Lanka */ LK: '🇱🇰',
  /* St. Kitts & Nevis */ KN: '🇰🇳',
  /* St. Lucia */ LC: '🇱🇨',
  /* St. Vincent & Grenadines */ VC: '🇻🇨',
  /* Sudan */ SD: '🇸🇩',
  /* Suriname */ SR: '🇸🇷',
  /* Sweden */ SE: '🇸🇪',
  /* Switzerland */ CH: '🇨🇭',
  /* Syria */ SY: '🇸🇾',
  /* Taiwan */ TW: '🇹🇼',
  /* Tajikistan */ TJ: '🇹🇯',
  /* Tanzania */ TZ: '🇹🇿',
  /* Thailand */ TH: '🇹🇭',
  /* Timor-Leste */ TL: '🇹🇱',
  /* Togo */ TG: '🇹🇬',
  /* Trinidad & Tobago */ TT: '🇹🇹',
  /* Tunisia */ TN: '🇹🇳',
  /* Turkey */ TR: '🇹🇷',
  /* Turkmenistan */ TM: '🇹🇲',
  /* Tuvalu */ TV: '🇹🇻',
  /* U.S. Virgin Islands */ VI: '🇻🇮',
  /* Uganda */ UG: '🇺🇬',
  /* Ukraine */ UA: '🇺🇦',
  /* United Arab Emirates */ AE: '🇦🇪',
  /* United Kingdom */ GB: '🇬🇧',
  /* United States */ US: '🇺🇸',
  /* Uruguay */ UY: '🇺🇾',
  /* Uzbekistan */ UZ: '🇺🇿',
  /* Vanuatu */ VU: '🇻🇺',
  /* Venezuela */ VE: '🇻🇪',
  /* Vietnam */ VN: '🇻🇳',
  /* Western Sahara */ EH: '🇪🇭',
  /* Yemen */ YE: '🇾🇪',
  /* Zambia */ ZM: '🇿🇲',
  /* Zimbabwe */ ZW: '🇿🇼',
} as const;
